import React from "react";
import { Box } from "@mui/material";
import InnerShadowBox from "components/Shared/InnerShadowBox";
import { BASE_CONSTANTS } from "constants/baseConstants";

export const CardContent = ({
  children,
  grow = false,
  shadowBox = false,
  disablePadding = false,
}) => {
  const ContentContainer = shadowBox ? InnerShadowBox : Box;

  return (
    <ContentContainer
      {...{
        ...(!disablePadding && {
          padding: BASE_CONSTANTS.PADDING_MD,
        }),
        ...(grow && { flexGrow: 1 }),
      }}
      style={{ overflowY: "auto" }}
    >
      {children}
    </ContentContainer>
  );
};
